import { render, staticRenderFns } from "./HistoryAnatomicalMark.vue?vue&type=template&id=0032d27c&scoped=true"
import script from "./HistoryAnatomicalMark.vue?vue&type=script&lang=js"
export * from "./HistoryAnatomicalMark.vue?vue&type=script&lang=js"
import style0 from "./HistoryAnatomicalMark.vue?vue&type=style&index=0&id=0032d27c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0032d27c",
  null
  
)

export default component.exports